import { render, staticRenderFns } from "./subdomain-dialog.vue?vue&type=template&id=457e845a&scoped=true&"
import script from "./subdomain-dialog.vue?vue&type=script&lang=js&"
export * from "./subdomain-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457e845a",
  null
  
)

export default component.exports